import { useState } from 'react';
import { useAuthStore } from '@/stores/authStore';
import { useNotificationStore } from '@/stores/notificationStore';
import { exitEntity } from '@/services/authService';
import { useTranslation } from '@/hooks/useTranslation';
import XIcon from '@assets/icons/XIcon';
import styles from './EntitySessionBanner.module.scss';

export function EntitySessionBanner() {
  const { t } = useTranslation();
  const isEntitySession = useAuthStore((s) => s.isEntitySession);
  const clientName = useAuthStore((s) => s.session?.organization?.name ?? 'entity');
  const addNotification = useNotificationStore((s) => s.addNotification);
  const [exiting, setExiting] = useState(false);

  if (!isEntitySession) return null;

  const handleExit = async () => {
    if (exiting) return;
    setExiting(true);
    try {
      const url = await exitEntity();
      window.location.href = url || '/';
    } catch {
      addNotification({
        variant: 'critical',
        title: t('K_NOTIF_ENTITY_EXIT_FAILED', 'Failed to exit entity mode. Please try again.'),
      });
      setExiting(false);
    }
  };

  return (
    <div className="entity-session-banner" role="status" aria-live="polite">
      <span className={styles.message}>
        {t('K_ENTITY_BLOCK_SWITCHED_TO', 'You are switched to {name}').replace('{name}', clientName)}
      </span>
      <button
        type="button"
        className={styles.exitButton}
        onClick={() => { void handleExit(); }}
        disabled={exiting}
      >
        <XIcon />
        {exiting ? t('K_LABEL_EXITING', 'Exiting…') : t('K_BUTTON_EXIT', 'Exit')}
      </button>
    </div>
  );
}
